import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../types/titles';
import SetupBiometryLayout from '../../components/auth/setup-biometry';

const Biometry = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.AUTH.SETUP_BIOMETRY}</title>
			</Helmet>
			<SetupBiometryLayout />
		</>
	);
};

export default Biometry;
